import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconGuestWifiProps } from './IconGuestWifi.types'
import * as Styled from './styles/IconGuestWifi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGuestWifi: FC<IconGuestWifiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGuestWifiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconGuestWifiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M7.914 21.535c.461-2.191 2.121-3.808 4.086-3.808 1.965 0 3.625 1.617 4.086 3.808m-1.703-6.425A2.382 2.382 0 1 1 12 12.726h2.383ZM2.5 6.559c5.242-5.247 13.746-5.25 18.992-.012l.008.012'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M5.25 8.84c3.746-3.746 9.824-3.746 13.57 0' vectorEffect='non-scaling-stroke' />
          <path d='M8.074 10.848a5.573 5.573 0 0 1 7.887 0' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconGuestWifi
